import gql from "graphql-tag";

export const deleteContentGroup = gql`
  mutation DeleteContentGroup($id: ID!) {
    deleteContentGroup(where: { id: $id }){
      id
    }
  }
`;
